interface SkeletonProps {
  width?: string;
  height?: string;
  class?: string;
}

export function Skeleton({ width = '100%', height = '1em', class: className = '' }: SkeletonProps) {
  return (
    <div
      class={`skeleton ${className}`}
      style={{ width, height }}
    />
  );
}

export function StatCardSkeleton() {
  return (
    <div class="stat-card">
      <Skeleton width="40px" height="40px" />
      <div style={{ flex: 1 }}>
        <Skeleton width="60%" height="1.5rem" class="skeleton-stat" />
        <Skeleton width="80%" height="0.75rem" />
      </div>
    </div>
  );
}

export function TableRowSkeleton({ cols = 7 }: { cols?: number }) {
  return (
    <tr>
      {Array.from({ length: cols }, (_, i) => (
        <td key={i}><Skeleton width={`${50 + Math.random() * 40}%`} /></td>
      ))}
    </tr>
  );
}
